import { ExternalLink } from "lucide-react";

export const HousecallProReviews = ({ url }) => {
  if (!url || !/^https:\/\/client\.housecallpro\.com\/reviews\/widget\/[0-9a-f-]{36}$/i.test(url)) return null;
  return <div className="w-full max-w-[1000px] mx-auto mb-10" data-testid="housecallpro-reviews">
    <iframe
      src={url}
      title="Meza Plumbing & Sewer customer reviews on Housecall Pro"
      width="100%"
      height="1000"
      loading="eager"
      referrerPolicy="strict-origin-when-cross-origin"
      data-testid="housecallpro-reviews-iframe"
      className="block w-full border-0 rounded-lg bg-white"
    />
    <a href={url} target="_blank" rel="noopener noreferrer" data-testid="housecallpro-reviews-external" className="mt-3 inline-flex items-center gap-2 text-xs text-slate-400 hover:text-electric transition-colors">View reviews on Housecall Pro<ExternalLink className="w-3.5 h-3.5" /></a>
  </div>;
};